import type React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";
import type { OrgType } from "@/types/orgTypes";

interface OrgTypeGateProps {
  orgTypes: OrgType[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function OrgTypeGate({
  orgTypes,
  children,
  fallback,
}: OrgTypeGateProps) {
  const { orgType, isLoading } = useAuth();

  // While auth is resolving, don't redirect prematurely
  if (isLoading) {
    return null;
  }

  // null orgType (org type not yet set) passes through to avoid locking out unknown orgs
  if (orgType !== null && !orgTypes.includes(orgType)) {
    // biome-ignore lint/complexity/noUselessFragments: --
    return fallback ? <>{fallback}</> : <Navigate replace to="/overview" />;
  }

  return <>{children}</>;
}
